import { useConfig } from '../../../providers/envConfig'
import { ConsentResponseWithAccountDetails, ConsentStatus } from '../../../types/Account'
import useFetch from '../../helpers/useFetch'

// usePatchConsentApprove is a custom hook to update consent data with the /accounts/{id}/consent endpoint.
const usePatchConsentApprove = (id: string, jwt: string) => {
  const envConfig = useConfig()

  const url = `${envConfig.vpcUrl}/accounts/${id}/consent`
  const fields: RequestInit = {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      'x-bnet-key': envConfig.bnetKey,
      Authorization: `Bearer ${jwt}`,
    },
    credentials: 'include',
    body: JSON.stringify({
      status: ConsentStatus.APPROVED,
    }),
  }

  const { data, loading, error, callFetch } = useFetch<ConsentResponseWithAccountDetails>(
    url,
    fields,
  )

  return { data, loading, error, callFetch }
}

export default usePatchConsentApprove
